
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offer/[[...type]]",
      function () {
        return require("private-next-pages/offer/[[...type]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/offer/[[...type]]"])
      });
    }
  